import React from 'react';
import PropTypes from 'prop-types';
import {ZOOM_MENU} from './AnimationZoom.constants';
import {ZoomMenu} from '@learningblocks/shared-components';
import cname from '../WidgetStyles';

/**
 * AnimationZoom:
 *  - Component to add ZoomFeature on LottiePlayer
 *  - Works best with AnimationBlock component
 */
export function AnimationZoom(props) {
  const [scale, setScale] = React.useState(1.0);

  const onChange = (value) => {
    if (value >= ZOOM_MENU.MIN && value <= ZOOM_MENU.MAX) {
      setScale(value);
    }
  };

  const setNewStyle = (style) => ({
    ...style,
    overflow: 'scroll',
    tabIndex: '0',
  });

  const setElemStyle = (style) => ({
    ...style,
    transform: `scale(${scale})`,
    transformOrigin: 'left top',
    //height: 'unset',
    //width: 'unset',
  });

  const renderChild = (component) =>
    React.cloneElement(component, {
      ...component.props,
      style: setNewStyle(component.props.style),
      elemStyle: setElemStyle(component.props.elemStyle),
    });

  return (
    <>
      {renderChild(props.children)}
      <ZoomMenu
        className={cname.zoomMenu}
        zoomValue={scale}
        setZoom={onChange}
        zoomRate={ZOOM_MENU.RATE}
        maxZoom={ZOOM_MENU.MAX}
        minZoom={ZOOM_MENU.MIN}
        dropdownOptions={ZOOM_MENU.OPTIONS}
      />
    </>
  );
}

AnimationZoom.propTypes = {
  /**
   * LottiePlayer component
   */
  children: PropTypes.element,
};

AnimationZoom.defaultProps = {
  style: {},
};
